<div class="modal-wrapper modal-large">
    <section class="page-title">
        <h1><strong>Vincular empresa</strong></h1>
        <mat-icon (click)="fechar()" style="cursor: pointer;">
            close
        </mat-icon>
    </section>

    <section class="filtros">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Buscar por nome, razão social ou CNPJ</mat-label>
            <input matInput type="text" (input)="aplicarFiltro($event)" [(ngModel)]="filterValue"
                placeholder="Digite para filtrar" />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </section>

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort class="use-divider-between use-sticky-header">
            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear> Nome </th>
                <td mat-cell *matCellDef="let empresa" style="height: 65px;">
                    <mat-radio-group [(ngModel)]="empresaSelecionadaId">
                        <mat-radio-button [value]="empresa.idEmpresa" style="cursor: pointer;">
                            {{empresa.nomeFantasia}}<br />{{empresa.razaoSocial}}
                        </mat-radio-button>
                    </mat-radio-group>
                </td>   
            </ng-container>


            <ng-container matColumnDef="cnpj">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear style="width: 25%;"> CNPJ </th>
                <td mat-cell *matCellDef="let empresa"> {{empresa.cnpj}} </td>
            </ng-container>

            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear style="width: 15%;"> Estado </th>
                <td mat-cell *matCellDef="let empresa"> {{empresa.estado}} </td>
            </ng-container>

            <ng-container matColumnDef="cidade">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear style="width: 15%;"> Cidade </th>
                <td mat-cell *matCellDef="let empresa"> {{empresa.cidade}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <div class="modal-footer">
        <button matButton="filled" [disabled]="!empresaSelecionadaId" (click)="vincularEmpresa()">
            Vincular empresa selecionada
        </button>
    </div>
</div>